module.exports = __webpack_public_path__ + "img/BGMain3.5953be15.jpg";